import React, { useEffect, useState } from 'react';
import styled from 'styled-components';
import GlobalStyle, { TextColorLight, TextColor } from '../styles/global';
import Header from '../components/header';
import { Container } from '../styles/styles';
import { formatDate, formatTime, sumMoedas } from '../utils';
import { getUserHistory, getUserData } from '../controllers/userController';
import { getMoedasAtribuidas, getMoedasAtribuidasId, getDistribuicoesMoedas, getResgates } from '../controllers/dashboardController';
import { BackBar, BackButton, ViewContainer } from '../styles/global';
import { useNavigate } from 'react-router-dom';

import logo from '../assets/icons/logo-banco-da-felicidade.svg';
import giftIcon from '../assets/icons/icon-gift.png';

import coin1 from '../assets/icons/moeda-1.svg';
import coin5 from '../assets/icons/moeda-5.svg';
import coin10 from '../assets/icons/moeda-10.svg';
import coin50 from '../assets/icons/moeda-50.svg';
import coin100 from '../assets/icons/moeda-100.svg';

// Estilos para as abas
const TabsContainer = styled.div`
  display: flex;
  justify-content: space-between;
  gap: 10px;
  margin-bottom: 20px;
  overflow-x: auto;
`;

const TabButton = styled.button`
  background-color: ${(props) => (props.active ? '#F59D14' : '#fff2e0')};
  color: ${(props) => (props.active ? TextColorLight : TextColor)};
  padding: 10px;
  border: none;
  cursor: pointer;
  border-radius: 5px;
  &:hover {
    background-color: #F59D14;
    color: ${(props) => (props.active ? '' : TextColorLight)};
  }
`;

const TabContent = styled.div`
  display: ${(props) => (props.active ? 'block' : 'none')};
  overflow-x: auto;
`;

function Historicos() {
    const [activeTab, setActiveTab] = useState(1);
    const [historicoPessoal, setHistoricoPessoal] = useState([]);
    const [emocaoMoedas, setEmocaoMoedas] = useState([]);
    const [emocaoMoedasUsuario, setEmocaoMoedasUsuario] = useState([]);
    const [distribuicaoMoedas, setDistribuicaoMoedas] = useState([]);
    const [distribuicaoMoedasUsuario, setDistribuicaoMoedasUsuario] = useState([]);
    const [resgates, setResgates] = useState([]);
    const user = JSON.parse(localStorage.getItem('user'));
    const navigate = useNavigate();

    useEffect(() => {
        const fetchData = async () => {            
            try {
                console.log('Buscando histórico do usuário...');
                const userHistory = await getUserHistory(user.idusuario);
                
                // Filtrar distribuições enviadas
                const distribuicoesEnviadas = userHistory.filter(h => h.type === 'credito_enviado');
                
                // Verificar tipos de histórico
                const tiposHistorico = [...new Set(userHistory.map(h => h.type))];
                setHistoricoPessoal(userHistory);

                const allMoedas = await getMoedasAtribuidas();
                setEmocaoMoedas(allMoedas);

                const userMoedas = await getMoedasAtribuidasId(user.idusuario);
                setEmocaoMoedasUsuario(userMoedas);

                const allDistribuicoes = await getDistribuicoesMoedas();
                const manualDistribuicoes = allDistribuicoes.filter((dist) => dist.periodo === 'manual');
                console.log('Distribuições manuais:', manualDistribuicoes.length);
                setDistribuicaoMoedas(manualDistribuicoes);

                const userDistribuicoes = manualDistribuicoes.filter((dist) => dist.id_distribuidor === user.idusuario);
                setDistribuicaoMoedasUsuario(userDistribuicoes);

                const resgatesData = await getResgates();
                setResgates(resgatesData);

            } catch (error) {
                console.error('ERRO ao carregar os dados:', error);
            }
        };

        fetchData();
    }, [user.idusuario]);

    // Função auxiliar para renderizar as moedas com ícones
    const renderMoedasComIcones = (moedasObj) => {
        let moedas;
        if (typeof moedasObj === 'string') {
            try {
                moedas = JSON.parse(moedasObj);
            } catch {
                moedas = {};
            }
        } else {
            moedas = moedasObj || {};
        }

        const items = [];
        
        if (moedas["1"] && moedas["1"] > 0) {
            items.push(
                <React.Fragment key="1">
                    <img src={coin1} alt="1 Moeda" /> {moedas["1"]}
                </React.Fragment>
            );
        }
        if (moedas["5"] && moedas["5"] > 0) {
            items.push(
                <React.Fragment key="5">
                    <img src={coin5} alt="5 Moedas" /> {moedas["5"]}
                </React.Fragment>
            );
        }
        if (moedas["10"] && moedas["10"] > 0) {
            items.push(
                <React.Fragment key="10">
                    <img src={coin10} alt="10 Moedas" /> {moedas["10"]}
                </React.Fragment>
            );
        }
        if (moedas["50"] && moedas["50"] > 0) {
            items.push(
                <React.Fragment key="50">
                    <img src={coin50} alt="50 Moedas" /> {moedas["50"]}
                </React.Fragment>
            );
        }
        if (moedas["100"] && moedas["100"] > 0) {
            items.push(
                <React.Fragment key="100">
                    <img src={coin100} alt="100 Moedas" /> {moedas["100"]}
                </React.Fragment>
            );
        }

        return items.length > 0 ? items : <span>Nenhuma moeda</span>;
    };

    return (
        <>
            <Header />
            <GlobalStyle />
            <Container fullWidth direction="column" align="center" justify="center">
                <Container direction="column" align="center" width="100%">
                    <BackBar>
                        <BackButton onClick={() => navigate(-1)}>← Voltar</BackButton>
                    </BackBar>
                    <ViewContainer align="left">
                        <h2>Históricos</h2>
                        <TabsContainer>
                            <TabButton active={activeTab === 1} onClick={() => setActiveTab(1)}>Meu Histórico</TabButton>
                            <TabButton active={activeTab === 3} onClick={() => setActiveTab(3)}>Minhas Emoções</TabButton>
                            <TabButton active={activeTab === 5} onClick={() => setActiveTab(5)}>Minhas Distribuições</TabButton>
                            <TabButton active={activeTab === 2} onClick={() => setActiveTab(2)}>Todas Emoções</TabButton>
                            <TabButton active={activeTab === 4} onClick={() => setActiveTab(4)}>Todas Distribuições</TabButton>
                            <TabButton active={activeTab === 6} onClick={() => setActiveTab(6)}>Resgates de Prêmios</TabButton>
                        </TabsContainer>

                        {/* Histórico Pessoal */}
                        <TabContent active={activeTab === 1}>
                            <h3>Meu Histórico</h3>
                            <table>
                                <thead>
                                    <tr>
                                        <th>Tipo</th>
                                        <th>Data</th>
                                        <th>Moedas</th>
                                    </tr>
                                </thead>
                                <tbody>
                                    {historicoPessoal.map((item, index) => {
                                        const remetente = item?.distribuidor ?? null;
                                        const remetenteUnidade = item?.distribuidorUnidade ?? null;
                                        const tipo_moeda = item?.tipo_moeda;

                                        return (
                                            <tr key={index}>
                                                <td>
                                                    <div className="item-type">
                                                        {item.type === 'resgate' ? (
                                                            <img src={giftIcon} alt={item.type} />
                                                        ) : (
                                                            <img src={logo} alt={item.type} />
                                                        )}
                                                        <h5>
                                                            {item.nome} 
                                                            {item.type === 'resgate' && <span> x {item.qtd}</span>}
                                                            
                                                            {(item.type === "credito" || item.type === "remocao") && (
                                                                <div style={{ marginTop: '4px', fontSize: '11px', fontWeight: '500', color: '#6c757d' }}>
                                                                    {remetente && (
                                                                        <div>
                                                                            <span style={{color: '#D4AC0D'}}>
                                                                                De: {remetente} {remetenteUnidade && `(${remetenteUnidade})`}
                                                                            </span>
                                                                        </div>
                                                                    )}
                                                                    {tipo_moeda && (
                                                                        <div>
                                                                            <span style={{ textTransform: 'capitalize', color: '#000000ff' }}>
                                                                                {'moeda ' + tipo_moeda}
                                                                            </span>
                                                                        </div>
                                                                    )}
                                                                </div>
                                                            )}
                                                            
                                                            {item.type === 'remocao' && item.receptor && (
                                                                <div style={{ fontSize: '12px', color: '#000000', marginTop: '4px' }}>
                                                                    {item.receptor} ({item.receptorUnidade})
                                                                </div>
                                                            )}
                                                        </h5>
                                                    </div>
                                                </td>
                                                <td>
                                                    <div className="item-time-date">
                                                        <small>{formatTime(item.date)}</small>
                                                        <small>{formatDate(item.date)}</small>
                                                    </div>
                                                </td>
                                                <td>
                                                    {item.type === 'credito' 
                                                        ? `+${sumMoedas(item.amount)}` 
                                                        : item.type === 'remocao' 
                                                        ? `-${sumMoedas(item.amount)}` 
                                                        : `-${item.amount}`}
                                                </td>
                                            </tr>
                                        );
                                    })}
                                </tbody>
                            </table>
                        </TabContent>

                        {/* Emoções de Moedas do Sistema */}
                        <TabContent active={activeTab === 2}>
                            <h3>Todas Emoções do Sistema</h3>
                            <table>
                                <thead>
                                    <tr>
                                        <th>Motivo</th>
                                        <th>Data Emoção</th>
                                        <th>Distribuidor</th>
                                        <th>Emocionador</th>
                                        <th>Data Criação</th>
                                    </tr>
                                </thead>
                                <tbody>
                                    {emocaoMoedas.map((moeda, index) => (
                                        <tr key={index}>
                                            <td><div className="item-type"><img src={logo} /><h5>{moeda.motivo}</h5></div></td>
                                            <td><small>{formatDate(moeda.criacao)}</small></td>
                                            <td><div className="item-detalhes">
                                                <small><b>{moeda.distribuidor}</b></small>
                                                <span>{moeda.distribuidorUnidade}</span>
                                            </div></td>
                                            <td><div className="item-detalhes">
                                                <small>{moeda.emocionador}</small>
                                                <span>{moeda.emocionadorUnidade}</span>
                                            </div></td>
                                            <td><small>{formatDate(moeda.data_emocao)}</small></td>
                                        </tr>
                                    ))}
                                </tbody>
                            </table>
                        </TabContent>

                        {/* Emoções de Moedas do Usuário */}
                        <TabContent active={activeTab === 3}>
                            <h3>Minhas Emoções</h3>
                            <table>
                                <thead>
                                    <tr>
                                        <th>Motivo</th>
                                        <th>Data Emoção</th>
                                        <th>Distribuidor</th>
                                        <th>Emocionador</th>
                                        <th>Data Criação</th>
                                    </tr>
                                </thead>
                                <tbody>
                                    {emocaoMoedasUsuario.map((moeda, index) => (
                                        <tr key={index}>
                                            <td><div className="item-type"><img src={logo} /><h5>{moeda.motivo}</h5></div></td>
                                            <td><small>{formatDate(moeda.criacao)}</small></td>
                                            <td><div className="item-detalhes">
                                                <small><b>{moeda.distribuidor}</b></small>
                                                <span>{moeda.distribuidorUnidade}</span>
                                            </div></td>
                                            <td><div className="item-detalhes">
                                                <small>{moeda.emocionador}</small>
                                                <span>{moeda.emocionadorUnidade}</span>
                                            </div></td>
                                            <td><small>{formatDate(moeda.data_emocao)}</small></td>
                                        </tr>
                                    ))}
                                </tbody>
                            </table>
                        </TabContent>

                        {/* Distribuições de Moedas do Sistema */}
                        <TabContent active={activeTab === 4}>
                            <h3>Distribuições de Moedas do Sistema</h3>
                            <table>
                                <thead>
                                    <tr>
                                        <th>Moedas Distribuídas</th>
                                        <th>Distribuidor</th>
                                        <th>Emocionador</th>
                                        <th>Data</th>
                                    </tr>
                                </thead>
                                <tbody>
                                    {distribuicaoMoedas.map((dist, index) => (
                                        <tr key={index}>
                                            <td><div className="item-coins">
                                                {renderMoedasComIcones(dist.moedas_distribuidas)}
                                            </div>
                                            </td>
                                            <td><div className="item-detalhes">
                                                <small><b>{dist.distribuidor}</b></small>
                                                <span>{dist.distribuidorUnidade}</span>
                                            </div></td>
                                            <td><div className="item-detalhes">
                                                <small>{dist.emocionador}</small>
                                                <span>{dist.emocionadorUnidade}</span>
                                            </div></td>
                                            <td><small>{formatDate(dist.data_atribuicao)}</small></td>
                                        </tr>
                                    ))}
                                </tbody>
                            </table>
                        </TabContent>

                        {/* Distribuições de Moedas do Usuário */}
                        <TabContent active={activeTab === 5}>
                            <h3>Minhas Distribuições de Moedas</h3>
                            {(() => {
                                return null;
                            })()}
                            <table>
                                <thead>
                                    <tr>
                                        <th>Tipo / Para quem</th>
                                        <th>Moedas Distribuídas</th>
                                        <th>Data</th>
                                        <th>Valor Total</th>
                                    </tr>
                                </thead>
                                <tbody>
                                    {/* Verifica se há dados */}
                                    {distribuicaoMoedasUsuario.length === 0 && 
                                     historicoPessoal.filter(item => item.type === 'credito_enviado').length === 0 && (
                                        <tr>
                                            <td colSpan="4" style={{textAlign: 'center', padding: '20px', color: '#666'}}>
                                                Nenhuma distribuição encontrada
                                            </td>
                                        </tr>
                                    )}
                                    
                                    {/* Distribuições em lote (admin) */}
                                    {distribuicaoMoedasUsuario.map((dist, index) => {
                                        return (
                                            <tr key={`lote-${index}`}>
                                                <td>
                                                    <div className="item-type">
                                                        <img src={logo} alt="Distribuição em lote" />
                                                        <h5>
                                                            //Distribuição em lote
                                                            <div style={{ fontSize: '12px', color: '#666', marginTop: '4px' }}>
                                                                Para: <b>{dist.emocionador}</b>
                                                                {dist.emocionadorUnidade && <span> ({dist.emocionadorUnidade})</span>}
                                                            </div>
                                                            {dist.tipo_moeda && (
                                                                <div style={{ fontSize: '11px', color: '#000000ff', marginTop: '4px', textTransform: 'capitalize' }}>
                                                                    Tipo: moeda {dist.tipo_moeda}
                                                                </div>
                                                            )}
                                                        </h5>
                                                    </div>
                                                </td>
                                                <td>
                                                    <div className="item-coins">
                                                        {renderMoedasComIcones(dist.moedas_distribuidas)}
                                                    </div>
                                                </td>
                                                <td>
                                                    <div className="item-time-date">
                                                        <small>{formatDate(dist.data_atribuicao)}</small>
                                                    </div>
                                                </td>
                                                <td>
                                                    <span style={{ color: '#4CAF50', fontWeight: 'bold' }}>
                                                        +{sumMoedas(dist.moedas_distribuidas)}
                                                    </span>
                                                </td>
                                            </tr>
                                        );
                                    })}
                                    
                                    {/* Distribuições individuais (gestor emocionando) */}
                                    {historicoPessoal
                                        .filter(item => item.type === 'credito_enviado')
                                        .map((item, index) => {
                                            return (
                                                <tr key={`individual-${index}`}>
                                                    <td>
                                                        <div className="item-type">
                                                            <img src={logo} alt="Emoção individual" />
                                                            <h5>
                                                                {item.nome}
                                                                <div style={{ fontSize: '12px', color: '#666', marginTop: '4px' }}>
                                                                    Para: <b>{item.receptor}</b>
                                                                    {item.receptorUnidade && <span> ({item.receptorUnidade})</span>}
                                                                </div>
                                                                {item.tipo_moeda && (
                                                                    <div style={{ fontSize: '11px', color: '#000000ff', marginTop: '4px', textTransform: 'capitalize' }}>
                                                                        {item.tipo_moeda}
                                                                    </div>
                                                                )}
                                                            </h5>
                                                        </div>
                                                    </td>
                                                    <td>
                                                        <div className="item-coins">
                                                            {renderMoedasComIcones(item.amount)}
                                                        </div>
                                                    </td>
                                                    <td>
                                                        <div className="item-time-date">
                                                            <small>{formatTime(item.date)}</small>
                                                            <small>{formatDate(item.date)}</small>
                                                        </div>
                                                    </td>
                                                    <td>
                                                        <span style={{ color: '#4CAF50', fontWeight: 'bold' }}>
                                                            +{sumMoedas(item.amount)}
                                                        </span>
                                                    </td>
                                                </tr>
                                            );
                                        })
                                    }
                                </tbody>
                            </table>
                        </TabContent>

                        {/* Resgates de Prêmios */}
                        <TabContent active={activeTab === 6}>
                            <h3>Resgates de Prêmios</h3>
                            <table>
                                <thead>
                                    <tr>
                                        <th>Prêmio</th>
                                        <th>Usuário</th>
                                        <th>Data</th>
                                        <th>Status</th>
                                        <th>Valor resgatado</th>
                                    </tr>
                                </thead>
                                <tbody>
                                    {resgates.map((resgate, index) => (
                                        <tr key={index}>
                                            <td><div className="item-type">
                                                <img src={giftIcon} />
                                                <h5>{resgate.nome} <span> x{resgate.qtd}</span></h5>
                                            </div></td>
                                            <td><div className="item-detalhes">
                                                <small>{resgate.usuario}</small>
                                                <span>{resgate.unidade}</span>
                                            </div></td>
                                            <td><div className="item-detalhes-data">
                                                <small>{formatDate(resgate.criacao)}</small>
                                                <small>{formatTime(resgate.criacao)}</small>
                                            </div></td>
                                            <td><small>{resgate.status}</small></td>
                                            <td>{resgate.valor_moeda_resgatado}</td>
                                        </tr>
                                    ))}
                                </tbody>
                            </table>
                        </TabContent>
                    </ViewContainer >
                </Container >
            </Container >
        </>
    );
}

export default Historicos;